module.exports = __webpack_public_path__ + "img/icon02.e3bdfbb3.png";